import {
  buildSectionSelector,
  normalizeSectionId,
  sectionRenderer
} from '@theme/section-renderer';

import {
  requestIdleCallback,
  onDocumentReady
} from '@theme/utilities';

/* -------------------------------------------
  GLOBAL MENU STATE (Fabric compatible)
------------------------------------------- */
window.isMenuOpen = false;

document.addEventListener('menuOpened', () => {
  window.isMenuOpen = true;
});

document.addEventListener('menuClosed', () => {
  window.isMenuOpen = false;
});

/* -------------------------------------------
  SECTIONS THAT SHOULD NEVER RE-RENDER
------------------------------------------- */
const SKIP_SECTIONS = [
  'header',
  'header-drawer',
  'mobile-menu',
  'announcement-bar'
];

/* -------------------------------------------
  HYDRATE SINGLE SECTION (SAFE)
------------------------------------------- */
async function hydrateSection(sectionId, url) {
  // ❌ Skip menu-related sections
  if (SKIP_SECTIONS.includes(sectionId)) {
    return;
  }

  // ❌ Skip while menu is open
  if (window.isMenuOpen) {
    return;
  }

  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById( 
    buildSectionSelector(normalizedId)
  );

  // ❌ Section missing or already hydrated
  if (!section || section.dataset.hydrated === 'true') {
    return;
  }

  // ❌ No lazy hydration target → do nothing
  if (!section.querySelector('[data-lazy-hydration]')) {
    return;
  }

  try {
    await sectionRenderer.renderSection(normalizedId, {
      cache: false,
      url
    });

    section.dataset.hydrated = 'true';
    console.log(`[Hydrated] ${sectionId}`);
  } catch (error) {
    console.error(`[Hydration Failed] ${sectionId}`, error);
  }
}

/* -------------------------------------------
  PUBLIC HYDRATE API
------------------------------------------- */
export function hydrate(sectionId, url) {
  onDocumentReady(() => {
    requestIdleCallback(() => {
      hydrateSection(sectionId, url);
    });
  });
}
